import { render, staticRenderFns } from "./tradeChance.vue?vue&type=template&id=2d659748&scoped=true&"
import script from "./tradeChance.vue?vue&type=script&lang=js&"
export * from "./tradeChance.vue?vue&type=script&lang=js&"
import style0 from "./tradeChance.vue?vue&type=style&index=0&id=2d659748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d659748",
  null
  
)

export default component.exports